/**
 * Token storage abstraction — allows swapping localStorage (web) for
 * SecureStore (mobile) or any other storage backend.
 */
export interface ITokenStorage {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;
}

/**
 * Default browser-based token storage using localStorage.
 * SSR-safe: returns null / no-ops when `window` is undefined.
 */
export class BrowserTokenStorage implements ITokenStorage {
    getItem(key: string): string | null {
        if (typeof window === 'undefined') return null;
        return localStorage.getItem(key);
    }

    setItem(key: string, value: string): void {
        if (typeof window === 'undefined') return;
        localStorage.setItem(key, value);
    }

    removeItem(key: string): void {
        if (typeof window === 'undefined') return;
        localStorage.removeItem(key);
    }
}
